export enum DivertLaneModal {
  INVALID_DIVERT_LANE_CODE = "INVALID_DIVERT_LANE_CODE",
  EMPTY_DIVERT_LANE_CODE = "EMPTY_DIVERT_LANE_CODE",
  ASSIGNMENT_FAILED = "ASSIGNMENT_FAILED",
}
